<template>
  <div>
    <!-- 省市区选择 -->
    <van-popup v-model="show" position="bottom">
      <van-area
        :area-list="areaList"
        :columns-num="columnsNum"
        @confirm="confirm"
        @cancel="show = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';

export default {
  name: 'NxArea',
  model: {
    prop: 'data',
    event: 'onDataChange',
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
    },
    // 省市区显示列数， 3-省市区，2-省市，1-省
    columnsNum: {
      type: Number,
      default: () => 3,
    },
  },
  data() {
    return {
      show: false,
      areaList,
    };
  },
  watch: {
    visible: {
      handler(visible) {
        this.show = visible;
      },
    },
    show: {
      handler(show) {
        this.$emit('update:visible', show);
      },
    },
  },
  created() {
  },
  methods: {
    confirm(list) {
      // 确认省市区
      this.$emit('onDataChange', list);
      this.$emit('confirm', list);
      this.show = false;
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
